// extracted by mini-css-extract-plugin
export var billingDate = "styles_billingDate__+deRp";
export var button = "styles_button__Cc5S6";
export var collapsibleBar = "styles_collapsibleBar__--8TA";
export var collapsibleBarContainer = "styles_collapsibleBarContainer__X4ugC";
export var content = "styles_content__nEDMl";
export var details = "styles_details__akU0e";
export var header = "styles_header__sy7RP";
export var isOpen = "styles_isOpen__iL92o";
export var orderHeader = "styles_orderHeader__R2ehZ";
export var saleType = "styles_saleType__l47OG";
export var shipTo = "styles_shipTo__7WfyF";
export var title = "styles_title__ar+-m";
export var tooltip = "styles_tooltip__SxrcJ";
export var total = "styles_total__xQPEZ";